import axios from 'axios'
import qs from 'qs'


const kb = 1024;
const mb = 1024 * kb;
const gb = 1024 * mb;

import { ElMessage, ElMessageBox, ElLoading} from 'element-plus'

const faIcons = {
    'pdf': 'fa-file-pdf-o',
    'png': 'fa-file-photo-o',
    'bmp': 'fa-file-photo-o',
    'gif': 'fa-file-photo-o',
    'jpg': 'fa-file-photo-o',
    'jpeg': 'fa-file-photo-o',
    'xls': 'fa-file-excel-o',
    'xlsx': 'fa-file-excel-o',
    'doc': 'fa-file-word-o',
    'docx': 'fa-file-word-o',
    'ppt': 'fa-file-powerpoint-o',
    'pptx': 'fa-file-powerpoint-o',
    'zip': 'fa-file-zip-o',
    'rar': 'fa-file-zip-o',
    '7z': 'fa-file-zip-o',
    'mp3': 'fa-file-sound-o',
    'mav': 'fa-file-sound-o',
    'mp4': 'fa-file-movie-o',
    '3gp': 'fa-file-movie-o',
    'txt': 'fa-file-text-o'

}
export default {


    /**
     * 获取用户信息
     * {
            "contractAddr": "GuangZhou",
            "mobilePhone": "18926171600",
            "supervisorType": 0,
            "emailAddr": "ting.chen@hong-feng.com",
            "sex": 0,
            "isAdmin": 1,
            "userName": "超级管理员",
            "userCode": "admin",
            "status": 0
        }
     */
    getUserInfoFromLocal() {
        let userInfoStr = localStorage.getItem('userInfo');

        return JSON.parse(userInfoStr);
    },
    setEmpty(obj) {
        Object.keys(obj).forEach((key) => {
            obj[key] = "";
        })
    },
    toFileSize(size) {
        if (size) {
            if (size >= gb) {
                return (size / gb).toFixed(2) + " GB";
            } else if (size >= mb) {
                return (size / mb).toFixed(2) + " MB";
            } else if (size >= kb) {
                return (size / kb).toFixed(2) + " KB";
            } else {
                return size + "B";
            }
        }
    },
    toFileIcon(fileName) {
        if (!fileName) {
            return 'fa-file'
        }
        let ext = "";
        let index = fileName.lastIndexOf('.');
        if (index >= 0) {
            ext = fileName.substring(index + 1);
            let icon = faIcons[ext];
            if (icon) {
                return icon;
            } else {
                return 'fa-file'
            }
        } else {
            return 'fa-file'
        }
    },
    leftPad(str, len) {
        return new Array(len - (str + '').length + 1).join('0') + str;
    },
    getUpdateTime() {
        //每分钟更新数据
        return 60 * 1000
    },
    isBlank(param) {
        if (param === null || param === undefined || param === '') {
            return true
        } else {
            return false
        }
    },
    getImage(attachId) {
        return `/core/base/c/download/image?attachId=${attachId}`
    },
    async isLogin() { //是否已登录

        let result = false;
        let url = '/core/base/a/user/isLogin';

        const res = await axios.post(url);
        // console.log('isLogin:', res);
        if (res) {
            if (res.data.state == 0 && res.data.result === true) {
                result = true;
            }
        }

        return result;
    },
    async isPlatformAdmin() { //是否平台管理员

        let result = false;
        let url = '/gdsti2/web/a/web/hasRole';


        const res = await axios.post(url, {roleCode: 'workplaceProjectAdmin,workplaceProjectAdmin_zhuhai,workplaceProjectAdmin_zhaoqing'});
        // console.log('isLogin:', res);
        if (res) {
            if (res.data.state == 0 && res.data.result === true) {
                result = true;
            }
        }

        return result;
    },
    async isUnitAdmin() { //是否依托单位管理员

        let result = false;
        let url = '/gdsti2/web/a/web/hasRole';


        // const res = await axios.post(url, qs.stringify({roleCode:'PlatformAdmin'}));
        const res = await axios.post(url, {roleCode: 'workplaceAdmin'});
        // console.log('isLogin:', res);
        if (res) {
            if (res.data.state == 0 && res.data.result === true) {
                result = true;
            }
        }

        return result;
    },
    async getUserInfo() { //获取当前登录用户信息

        let userInfo = null;
        let url = '/core/base/a/user/getUsersByUserCodeOne';

        const res = await axios.post(url);
        if (res) {
            if (res.data.state == 0) {
                userInfo = res.data.result;
            }
        }

        return userInfo;
    },
    async getUnitInfo() { //获取当前登录用户依托单位信息

        let unitInfo = null;
        let url = '/gdsti2/lab/c/labUnit/getUserUnitId';

        const res = await axios.post(url);
        if (res) {
            if (res.data.state == 0) {
                unitInfo = res.data.result;
            }
        }

        return unitInfo;
    },
    async loadMaskedData(type, relateData) { //获取敏感信息

        ElMessageBox.confirm(
            '是否查看敏感信息?',
            'Warning',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {

                //加载数据
                this.loadMaskedDataShow(type, relateData);
            })
            .catch(() => {

            });
    },
    async loadMaskedDataShow(type, relateData) { //获取敏感信息
        let url = '/gdsti2/web/c/webManager/getMaskedData';
        const res = await axios.post(url, {type:type, data: relateData});
        if (res) {
            if (res.data.state == 0) {
                ElMessageBox.alert(res.data.result, '数据');
            }
        }
    },
    async loadDataDictList(dictTypeCode) { //加载数据字典

        let param = {
            isHide: 0,
            noPage: 1,
            typeCode: dictTypeCode,
        }

        let dataList = [];

        const res = await axios.post('/core/base/a/dictInfo/list', param);
        if (res) {
            dataList = res.data.result;
        }

        return dataList;
    },
    //除法 arg1 / arg2
    //fixed 小数点后几位
    accDiv(arg1, arg2, fixed) {
        if(this.isBlank(arg1) || this.isBlank(arg2)){
            return '';
        }
        var t1 = 0, t2 = 0, r1, r2;
        try {
            t1 = arg1.toString().split(".")[1].length
        } catch (e) {
        }
        try {
            t2 = arg2.toString().split(".")[1].length
        } catch (e) {
        }
        r1 = Number(arg1.toString().replace(".", ""))
        r2 = Number(arg2.toString().replace(".", ""))
        var returnVal = this.accMul((r1 / r2), Math.pow(10, t2 - t1));
        return returnVal.toFixed(fixed);
    },
    //乘法
    accMul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length
        } catch (e) {
        }
        try {
            m += s2.split(".")[1].length
        } catch (e) {
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
    },
    //加法
    accAdd(arg1, arg2) {
        var num1 = arg1 + "";
        var num2 = arg2 + "";
        var baseNum, baseNum1, baseNum2;
        try {
            //取得第一个操作数小数点后有几位数字，注意这里的num1是字符串形式的
            baseNum1 = num1.split(".")[1].length;
        } catch (e) {
            //没有小数点就设为0
            baseNum1 = 0;
        }
        try {
            //取得第二个操作数小数点后有几位数字
            baseNum2 = num2.split(".")[1].length;
        } catch (e) {
            baseNum2 = 0;
        }
        //计算需要 乘上多少数量级 才能把小数转化为整数
        baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
        //把两个操作数先乘上计算所得数量级转化为整数再计算，结果再除以这个数量级转回小数
        return (num1 * baseNum + num2 * baseNum).toFixed(0) / baseNum;
        //https://my.oschina.net/u/2366960/blog/880477?_from=gitee_search
    },
    //减法 arg1 - arg2
    accSub(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split(".")[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },



}
